/**
 * CSV cell encoding for Excel/Sheets-safe exports (semicolon delimiter).
 * Neutralizes formula injection (`=`, `+`, `-`, `@`, tab, CR) per OWASP.
 */
export function neutralizeCsvFormula(value: string): string {
  if (value.length === 0) return value;
  const first = value[0];
  if (
    first === '=' ||
    first === '+' ||
    first === '-' ||
    first === '@' ||
    first === '\t' ||
    first === '\r'
  ) {
    return `'${value}`;
  }
  return value;
}

export function escapeCsvCell(value: string, delimiter: string): string {
  const cell = neutralizeCsvFormula(value);
  if (
    cell.includes('"') ||
    cell.includes('\n') ||
    cell.includes('\r') ||
    cell.includes(delimiter)
  ) {
    return `"${cell.replace(/"/g, '""')}"`;
  }
  return cell;
}
